import Alert from 'bootstrap/js/dist/alert'
import Button from 'bootstrap/js/dist/button'
import Carousel from 'bootstrap/js/dist/carousel'
import Collapse from 'bootstrap/js/dist/collapse'
import Dropdown from 'bootstrap/js/dist/dropdown'
import Modal from 'bootstrap/js/dist/modal'
import Offcanvas from 'bootstrap/js/dist/offcanvas'
import Popover from 'bootstrap/js/dist/popover'
import Scrollspy from 'bootstrap/js/dist/scrollspy'
import Tab from 'bootstrap/js/dist/tab'
import Toast from 'bootstrap/js/dist/toast'
import Tooltip from 'bootstrap/js/dist/tooltip'

/**
 * Open primary-nav dropdowns on hover at the navbar's desktop breakpoint.
 *
 * The markup keeps Bootstrap's click toggle for the collapsed (mobile) menu.
 * At desktop sizes those data attributes are removed, so the parent item acts
 * as a regular link while this code controls the dropdown's `show` state.
 */
const primaryNav = document.querySelector('#main-nav')
const desktopNav = window.matchMedia('(min-width: 768px)')

if (primaryNav) {
	const dropdowns = Array.from(primaryNav.querySelectorAll('.navbar-nav > .dropdown'))

	const closeDropdown = (dropdown) => {
		const toggle = dropdown.querySelector(':scope > .dropdown-toggle')
		const menu = dropdown.querySelector(':scope > .dropdown-menu')

		if (!toggle || !menu) {
			return
		}

		toggle.classList.remove('show')
		toggle.setAttribute('aria-expanded', 'false')
		menu.classList.remove('show')
	}

	const openDropdown = (dropdown) => {
		dropdowns.forEach((otherDropdown) => {
			if (otherDropdown !== dropdown) {
				closeDropdown(otherDropdown)
			}
		})

		const toggle = dropdown.querySelector(':scope > .dropdown-toggle')
		const menu = dropdown.querySelector(':scope > .dropdown-menu')

		if (!toggle || !menu) {
			return
		}

		toggle.classList.add('show')
		toggle.setAttribute('aria-expanded', 'true')
		menu.classList.add('show')
	}

	const updateDropdownMode = () => {
		dropdowns.forEach((dropdown) => {
			const toggle = dropdown.querySelector(':scope > .dropdown-toggle')

			if (!toggle) {
				return
			}

			if (desktopNav.matches) {
				toggle.removeAttribute('data-toggle')
				toggle.removeAttribute('data-bs-toggle')
			} else {
				closeDropdown(dropdown)
				toggle.setAttribute('data-toggle', 'dropdown')
				toggle.setAttribute('data-bs-toggle', 'dropdown')
			}
		})
	}

	dropdowns.forEach((dropdown) => {
		dropdown.addEventListener('pointerenter', () => {
			if (desktopNav.matches) {
				openDropdown(dropdown)
			}
		})

		dropdown.addEventListener('pointerleave', () => {
			if (desktopNav.matches) {
				closeDropdown(dropdown)
			}
		})

		dropdown.addEventListener('focusin', () => {
			if (desktopNav.matches) {
				openDropdown(dropdown)
			}
		})

		dropdown.addEventListener('focusout', (event) => {
			if (desktopNav.matches && !dropdown.contains(event.relatedTarget)) {
				closeDropdown(dropdown)
			}
		})

		dropdown.addEventListener('keydown', (event) => {
			if (desktopNav.matches && event.key === 'Escape') {
				closeDropdown(dropdown)
				dropdown.querySelector(':scope > .dropdown-toggle').focus()
			}
		})
	})

	desktopNav.addEventListener('change', updateDropdownMode)
	updateDropdownMode()
}

export {
	Alert,
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	Offcanvas,
	Popover,
	Scrollspy,
	Tab,
	Toast,
	Tooltip
}
